import React, {useState, useEffect} from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import commonService from "../../services/common-service";
import Spinner from "../../shared/Spinner";
import SnackAlert from "../../shared/SnackAlert";
import { useParams } from "react-router-dom";

export default function Parameters() {
    const {domain} = useParams()
    const [parameters, setParameters] = useState({});
    const [groups, setGroups] = useState([]);
    const [inputField, setInputField] = useState({});
    const [selectedIns, setSelectedIns] = useState(null);
    const [selectedGrp, setSelectedGrp] = useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    
    const handleChange=(e) => {
        setInputField({...inputField, [e.target.name]: e.target.value});
    }

    const getParameters=async() => {
        setSpinner(true);
        const user = JSON.parse(sessionStorage.getItem('userLogged'));
        let body = {domain: domain};
        if(user.email == "cwpadmin"){
            body.ins_description = 'cwp'
        }
        const res = await commonService.get_parameters(body);
        setParameters(res.data);
        setSpinner(false);
    }

    const onInsSelect=async(newValue) => {
        setSpinner(true);
        setSelectedIns(newValue);
        const res = await commonService.get_groups_by_ins_id({ins_id: newValue.ins_id, domain: domain});
        setGroups(res.data);
        setSpinner(false);
    }

    const onRecycle=async() => {
        setSpinner(true);
        inputField['domain'] = domain;
        const res = await commonService.recycle(inputField);
        if(res.data == true){
            getParameters();
            setMsg("Recycled Successfully");
            setSeverity('success');
        }else{
            setMsg("Error occured. Please try again later");
            setSeverity('error');
        }
        setAlert(true);
        setSpinner(false);
    }

    useEffect(()=>{
        getParameters();
    },[])

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <Typography variant="body1" className="font-bold">Parameters</Typography>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>onRecycle()}>
                                    Recycle
                                </Button>
                            </div>
                            <div className="mt-3">
                                <div className="row">
                                    <TableCard title="DBPIC" rows={parameters.pic} />
                                    <TableCard title="INTEGRAMOBILE" rows={parameters.integra} />
                                </div>
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}

const TableCard = ({ title, rows }) => {
  return (
    <div className="col-md-6 mb-3">
      <div className="card shadow-sm">
        <div
          className={`card-header text-white bg-blue`}
        >
          {title}
        </div>

        <div className="card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-striped mb-0">
              <thead>
                <tr>
                  <th>PAR_ID</th>
                  <th>PAR_NAME</th>
                  <th>PAR_VALUE</th>
                  <th>PAR_DESCRIPTION</th>
                </tr>
              </thead>

              <tbody>
                {rows?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.PAR_ID}</td>
                    <td>{row.PAR_NAME}</td>
                    <td>{row.PAR_VALUE}</td>
                    <td>{row.PAR_DESCRIPTION}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};